export enum QuotePanelsTabsList {
    SYMBOL = "symbol",
    WIZARD = "wizard",
    MONITOR = "monitor",
    ALERTS = "alerts",
    SOCIAL = "social",
    LEADERBOARD = "leaderboard",
    SCANNER = "scanner"
}

export function getquotePanelsTabsList(): string[][] {
    let res: string[][] = [];
    for (const n in QuotePanelsTabsList) {
        if (QuotePanelsTabsList.hasOwnProperty(n)) {
            res.push([n, (<any>QuotePanelsTabsList)[n]]);
        }
    }
    return res;
}

export function quotePanelsTabsParams(): object {
    let tabsParams: { id: string; label: string }[] = [
        { id: QuotePanelsTabsList.SYMBOL, label: "Quotes" },
       // { id: QuotePanelsTabsList.MONITOR, label: "Monitor" },
       // { id: QuotePanelsTabsList.WIZARD, label: "Tl Wizard" },
        //   { "id": QuotePanelsTabsList.ALERTS, "label": "Alerts" },
      //  { id: QuotePanelsTabsList.SOCIAL, label: "Social" },
    //    { id: QuotePanelsTabsList.LEADERBOARD, label: "Challenges" },
       // { id: QuotePanelsTabsList.SCANNER, label: "Scanner" }
    ];
    return tabsParams;
}
